import { TableHead, SearchData } from "../../../../common/dataClass/Default"

/**Review搜索数据 */
class ReviewSearchData extends SearchData{
  constructor() {
    super()
    /**店铺 */
    this.store = ''
    /**国家站点 */
    this.countrySite = ''
  }
  /**搜索数据请求体 */
  get getSearchAxiosBody(){
    return {
      page: this.page,
      row: 10,
      saleStatus: 0,
      storeName: this.store? this.store : null,
      countryArea: this.countrySite? this.countrySite : null,
      textFilter: this.text? this.text : null
    }
  }
}

/**Review表头 */
class AnalysisTableHead extends TableHead{
  constructor(name, prop, width) {
    super(name, prop, width)
  }
}

class AnalysisNewModule{
  /**Review表头 */
  static NEWANALYSISTABLEHEAD(){
    let arr = [
      new AnalysisTableHead('父ASIN', 'img', '100'),
      new AnalysisTableHead('子ASIN数量', 'name', '80'),
      new AnalysisTableHead('子ASIN', 'storeName', '100'),
      new AnalysisTableHead('图片', 'countrySiteName', '80'),
      new AnalysisTableHead('商品标题', 'unitName', '200'),
      new AnalysisTableHead('店铺名称', 'stockPrice', '100'),
      new AnalysisTableHead('国家站点', 'getSavePriceByTable', '80'),
      new AnalysisTableHead('流量', 'getCostSummaryByTable', '120'),
      new AnalysisTableHead('订单数量', 'getNetProfitOfGoodsByTable', '100'),
      new AnalysisTableHead('Review数量', 'getCostOfCommodityInvestmentByTable', '100'),
      new AnalysisTableHead('Feedback数量', 'getCommodityCollectionByTable', '80'),
      new AnalysisTableHead('流量/订单量', 'getShowNumAndActualNumByTable', '150'),
      new AnalysisTableHead('订单量/Review数量', 'disposalNum', '150'),
      new AnalysisTableHead('Review数量/Feedback数量', 'operssaate', '150'),
      new AnalysisTableHead('排名', '2d', '80'),
    ]
    return arr
  }
  /**销量表头 */
  static NEWSALESTABLEHEAD(){
    let arr = [
      new AnalysisTableHead('商品<br>图片', 'img', '100'),
      new AnalysisTableHead('商品型号<br>(ASIN)', 'name', '80'),
      new AnalysisTableHead('商品标题', 'unitName', '200'),
      new AnalysisTableHead('店铺名称', 'stockPrice', '100'),
      new AnalysisTableHead('国家站点', 'getSavePriceByTable', '80'),
      new AnalysisTableHead('计价<br>单位', 'storeName', '100'),
      new AnalysisTableHead('当期站内广告费(¥)', 'countrySiteName', '120'),
      new AnalysisTableHead('当期站外测评费(¥)', 'unitName1', '120'),
      new AnalysisTableHead('当期站外引流费(¥)', 'getCostSummaryByTable', '120'),
      new AnalysisTableHead('当期坏品<br>退货量', 'getNetProfitOfGoodsByTable', '100'),
      new AnalysisTableHead('当期非坏<br>品退货量', 'getCostOfCommodityInvestmentByTable', '100'),
      new AnalysisTableHead('本期显示销量', 'getCommodityCollectionByTable', '80'),
      new AnalysisTableHead('生产中/国内中转仓/海外中转仓<br>国际运输中/合计未入亚马逊仓库存量', 'getShowNumAndActualNumByTable', '250'),
      new AnalysisTableHead('更新时间', 'disposalNum', '100'),
    ]
    return arr
  }
}

export{ ReviewSearchData, AnalysisNewModule }
